import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import { useQuery } from "react-query";
import CasinoVideo from "./components/CasinoVideo";
import Timer from "./components/Timer";
import {
  CARD_ARRAY,
  cardArray,
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./CasinoGeneric";
import PlaceBet from "./components/PlaceBet";
import { useDispatch } from "react-redux";
import PlacedBet from "./components/PlacedBet";
import CasinoPage from "./components/CasinoPage";
import { useLocation } from "react-router-dom";
export default function Kbc() {
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];
  // const GAME_ID = "AAA";
  // const VIDEO_ID = CASINO_VIDEO.amarAkbarAnthony;
  const VIDEO_ID = "kbc";
  const dispatch = useDispatch();
  const [casinoPlData, setCasinoPlData] = useState([]);

  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );

  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);


  return (
     <CasinoPage
              casino={casinoData?.data}
              VIDEO_ID={VIDEO_ID}
              // VIDEO_ID={GAME_ID}
              GAME_ID={GAME_ID}
              // VIDEO_ID={CASINO_VIDEO.thirtyTwoCardB}
              //  VIDEO_ID={GAME_ID}
              // GAME_ID={GAME_ID}
              // shortName={"cards32a cards32b"}
              // gameName={"CARDS 32B"}
            >
    {/* <div className="center-main-container casino-page"> */}
    {/* <div className="center-container"> */}
      {/* <div className="casino-page-container kbc"> */}
        {/* <div className="casino-header"> */}
          {/* <span className="casino-name">
            K.B.C
            <a className="ms-1">
              <small>Rules</small>
            </a>
          </span>
          <span className="casino-rid d-none d-xl-inline-block">
            <small>
              Round ID: <span>144250430202221</span>
            </small>
          </span> */}
        {/* </div> */}
        {/* <div className="casino-title-header-mobile d-xl-none">
          <ul className="nav nav-tabs menu-tabs">
            <li className="nav-item">
              <div className="nav-link active">Game</div>
            </li>
            <li className="nav-item">
              <div className="nav-link">Placed Bet (0)</div>
            </li>
          </ul>
          <div className="pe-2">
            <span className="casino-rid">
              Round ID: <span>144250430202221</span>
            </span>
          </div>
        </div> */}
        {/* <div className=""> */}
          {/* <div className="casino-video"> */}
            {/* <div className="video-box-container"> */}
              {/* <div className="casino-video-box"> */}
                {/* <iframe src="/mediaplayer/kbc/d9401bf7-c24a-4b57-bb9f-bd344c6ee889?ip=122.160.119.41" /> */}
              {/* </div> */}
            {/* </div> */}
            {/* <div className="casino-video-cards" /> */}
            {/* <div className="clock flip-clock-wrapper">
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">4</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">4</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">3</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">3</div>
                    </div>
                  </a>
                </li>
              </ul>
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">7</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">7</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">6</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">6</div>
                    </div>
                  </a>
                </li>
              </ul>
            </div> */}
          {/* </div> */}
          <div className="casino-detail">
            <div className="casino-table">
              <div className="row row5 kbc-btns">
                <div className="col-12 col-md-4">
                  <div className="casino-odd-box-container">
                    <div className="casino-nation-name">
                      <b>[Q1] Red Black</b>
                    </div>
                    <div className="btn-group">
                      <input
                        type="radio"
                        className="btn-check"
                        id="redBlack-1"
                        name="redBlackBtn"
                        defaultValue={1}
                      />
                      <label
                        className="form-check-label btn"
                        htmlFor="redBlack-1"
                      >
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/icons/heart.png" />
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/icons/diamond.png" />
                      </label>
                      <input
                        type="radio"
                        className="btn-check"
                        id="redBlack-2"
                        name="redBlackBtn"
                        defaultValue={2}
                      />
                      <label
                        className="form-check-label btn"
                        htmlFor="redBlack-2"
                      >
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/icons/spade.png" />
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/icons/club.png" />
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="casino-odd-box-container">
                    <div className="casino-nation-name">
                      <b>[Q2] Odd Even</b>
                    </div>
                    <div className="btn-group">
                      <input
                        type="radio"
                        className="btn-check"
                        id="oddEven-1"
                        name="oddEvenBtn"
                        defaultValue={1}
                      />
                      <label className="form-check-label btn" htmlFor="oddEven-1">
                        Odd
                      </label>
                      <input
                        type="radio"
                        className="btn-check"
                        id="oddEven-2"
                        name="oddEvenBtn"
                        defaultValue={2}
                      />
                      <label className="form-check-label btn" htmlFor="oddEven-2">
                        Even
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="casino-odd-box-container">
                    <div className="casino-nation-name">
                      <b>[Q3] 7 Up-7 Down</b>
                    </div>
                    <div className="btn-group">
                      <input
                        type="radio"
                        className="btn-check"
                        id="upDown-1"
                        name="7UpDownBtn"
                        defaultValue={1}
                      />
                      <label className="form-check-label btn" htmlFor="upDown-1">
                        Up
                      </label>
                      <input
                        type="radio"
                        className="btn-check"
                        id="upDown-2"
                        name="7UpDownBtn"
                        defaultValue={2}
                      />
                      <label className="form-check-label btn" htmlFor="upDown-2">
                        Down
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row row5 kbc-btns kbcothers mt-xl-3">
                <div className="col-12 col-md-4">
                  <div className="casino-odd-box-container">
                    <div className="casino-nation-name">
                      <b>[Q4] 3 Card Judgement</b>
                    </div>
                    <div className="btn-group">
                      <input
                        type="radio"
                        className="btn-check"
                        id="cardj-1"
                        name="3cardj"
                        defaultValue={1}
                      />
                      <label className="form-check-label btn" htmlFor="cardj-1">
                        A23
                      </label>
                      <input
                        type="radio"
                        className="btn-check"
                        id="cardj-2"
                        name="3cardj"
                        defaultValue={2}
                      />
                      <label className="form-check-label btn" htmlFor="cardj-2">
                        456
                      </label>
                      <input
                        type="radio"
                        className="btn-check"
                        id="cardj-3"
                        name="3cardj"
                        defaultValue={3}
                      />
                      <label className="form-check-label btn" htmlFor="cardj-3">
                        8910
                      </label>
                      <input
                        type="radio"
                        className="btn-check"
                        id="cardj-4"
                        name="3cardj"
                        defaultValue={4}
                      />
                      <label className="form-check-label btn" htmlFor="cardj-4">
                        JQK
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="casino-odd-box-container">
                    <div className="casino-nation-name">
                      <b>[Q5] Suits</b>
                    </div>
                    <div className="btn-group">
                      <input
                        type="radio"
                        className="btn-check"
                        id="suits-1"
                        name="suit"
                        defaultValue={1}
                      />
                      <label className="form-check-label btn" htmlFor="suits-1">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/icons/spade.png" />
                      </label>
                      <input
                        type="radio"
                        className="btn-check"
                        id="suits-2"
                        name="suit"
                        defaultValue={2}
                      />
                      <label className="form-check-label btn" htmlFor="suits-2">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/icons/heart.png" />
                      </label>
                      <input
                        type="radio"
                        className="btn-check"
                        id="suits-3"
                        name="suit"
                        defaultValue={3}
                      />
                      <label className="form-check-label btn" htmlFor="suits-3">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/icons/club.png" />
                      </label>
                      <input
                        type="radio"
                        className="btn-check"
                        id="suits-4"
                        name="suit"
                        defaultValue={4}
                      />
                      <label className="form-check-label btn" htmlFor="suits-4">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/icons/diamond.png" />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="casino-last-result-title">
              <span>Last Result</span>
              <span>
                <a href="/casino-results/kbc">View All</a>
              </span>
            </div>
            <div className="casino-last-results"> */}
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
            {/* </div> */}
          </div>
        {/* </div> */}
        <div className="d-none" />
      {/* </div> */}
    {/* </div> */}
    {/* <div className="sidebar right-sidebar casino-right-sidebar sticky">
      <div className="sidebar-box my-bet-container">
        <div className="sidebar-title">
          <h4>My Bet</h4>
        </div>
        <div className="my-bets" />
      </div>
    </div> */}
  {/* </div> */}
  </CasinoPage>
  
  )
}
